import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { DesktopMenuItem } from './DesktopMenuItem';
import { PMenuItems, useCurrentUserMenu } from './helpers';

const useStyles = makeStyles((theme) => ({
  menuItems: {
    display: 'grid',
    gridAutoFlow: 'row',
    gridAutoRows: 'max-content',
    // boxShadow: '0px 8px 30px rgba(108, 108, 108, 0.15)',
    // borderRadius: '10px 0 0 10px',
    padding: '24px 16px',
    gap: '8px',
    borderRight: '1px solid #E5E7EB',
    background: '#FAFAFA',
	marginBottom: '32px',
    [theme.breakpoints.down('md')]: {
      gridAutoFlow: 'column',
      justifyContent: 'center',
      gridAutoColumns: '85px',
      gridAutoRows: '80px',
      borderRadius: '10px',
      overflowX: 'hidden',
    },
  },
}));

export const DesktopMenuList: React.FC<PMenuItems> = (props) => {
  const { user, className } = props;
  const { currentList } = useCurrentUserMenu({ user });
  // console.log(currentList);

  const classes = useStyles();
  return (
    <div className={clsx(classes.menuItems, className)}>
      {currentList.map((item) => {
        return <DesktopMenuItem item={item} key={item.path} />;
      })}
    </div>
  );
};
